const VERSION = '1.1.8';
export default VERSION;
